import { RECEIVE_INPUT_CONSTRAINTS } from '../receiving/constraints.js';
// Note is stored in inventory_log.info, a VARCHAR(100); the lot number shares receiving's bound.
// The explanation has its own VARCHAR(256) column and is written when a variance is closed.
export const INVENTORY_ADJUST_CONSTRAINTS = {
    quantity: { label: 'Quantity', max: 1_000_000_000 },
    unitCost: { label: 'Unit cost', max: 1_000_000_000 },
    note: { label: 'Note', maxLength: 100 },
    explanation: { label: 'Explanation', maxLength: 256 },
    lotNumber: RECEIVE_INPUT_CONSTRAINTS.lotNumber,
    countRows: { label: 'Rows', max: 200 },
    varianceRows: { label: 'Variances', max: 200 },
};
//# sourceMappingURL=constraints.js.map